/** Rows sorted by name, the order every hub list shows. */
export const byName = <T>(rows: T[], nameOf: (row: T) => string) =>
  [...rows].sort((left, right) => nameOf(left).localeCompare(nameOf(right)));
